import { createSelector } from "reselect";
import { RootState } from "RootReducer";
import { InboundWarehouses } from "@deliverr/inbound-client";

export const selectDestinationWarehouseFacilities: (state: RootState) => InboundWarehouses | undefined = createSelector(
  (state: RootState) => state.inbound.destinationWarehouseFacilities,
  (destinationWarehouseFacilities) => destinationWarehouseFacilities
);
